export const ENFORCE_MFA_CALLOUT_LOCAL_STORAGE_KEY = "EnforceMFACallout";
export const CANT_DISABLE_MFA_CALLOUT_LOCAL_STORAGE_KEY = "CantDisableMFACallout";
export const FILTERS_ORDER_SETTINGS_KEY = "personalMFAKeysFiltersOrder";
